import { AdditionalFeature } from "./additional-feature.types";

const additionalFeatures: AdditionalFeature[] = [
  {
    title: 'Gestão de Caixa',
    description: 'Controle completo das suas finanças. Acompanhe todas as formas de pagamento: crédito, débito, PIX, dinheiro. Relatórios detalhados por período.'
  },
  {
    title: 'Impressão Automática',
    description: 'Configure impressoras por setor. Cada pedido é impresso automaticamente no local correto: bar, cozinha ou confeitaria.'
  },
  {
    title: 'Controle de Estoque',
    description: 'Configure a quantidade de itens do menu ou deixe a quantidade ilimitado.'
  },
  // {
  //   title: 'Clientes Cadastrados',
  //   description: 'Mantenha um registro completo dos seus clientes, histórico de pedidos e preferências. Fidelize e entenda melhor seu público.'
  // },
  {
    title: 'Delivery Integrado',
    description: 'Sistema completo para delivery com cálculo automático de frete configurável.'
  },
  {
    title: 'Crédito para Clientes',
    description: 'Permita vendas a prazo com controle de valores em aberto. Registre débitos no fechamento do pedido e acompanhe o histórico completo de cada cliente.'
  },
  {
    title: 'Identidade Profissional',
    description: 'Transmita credibilidade com domínio próprio e visual personalizado. Logo do seu restaurante e URL exclusiva para seus clientes.'
  }
];


const AdditionalFeatures: React.FC = () => (
  <section className="px-4 sm:px-6 lg:px-8 bg-gray-50">
    <div className="max-w-7xl mx-auto">
      <div className="text-center mb-16">
        <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-4">
          E tem mais!
        </h2>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
        {additionalFeatures.map((feature, index) => (
          <div
            key={index}
            className="bg-gradient-to-br from-orange-50 to-amber-50 p-4 rounded-xl hover:shadow-lg transition"
          >
            <h3 className="text-2xl font-bold text-gray-900 mb-4">{feature.title}</h3>
            <p className="text-gray-600 mb-6">
              {feature.description}
            </p>
          </div>
        ))}


        {/* <div className="bg-white p-8 rounded-2xl shadow-xl">
          <h4 className="text-xl font-semibold text-gray-900 mb-4">Em breve</h4>
          <div className="space-y-4">
            <div className="flex items-start gap-3">
              <Calendar className="w-6 h-6 text-orange-500 flex-shrink-0 mt-1" />
              <div>
                <h5 className="font-medium text-gray-900">Calendário Inteligente</h5>
                <p className="text-gray-600 text-sm">Gerencie eventos, tarefas e reservas em um só lugar</p>
              </div>
            </div>
            <div className="flex items-start gap-3">
              <FileText className="w-6 h-6 text-orange-500 flex-shrink-0 mt-1" />
              <div>
                <h5 className="font-medium text-gray-900">Geração de NF</h5>
                <p className="text-gray-600 text-sm">Emita notas fiscais diretamente pelo sistema</p>
              </div>
            </div>
            <div className="flex items-start gap-3">
              <Truck className="w-6 h-6 text-orange-500 flex-shrink-0 mt-1" />
              <div>
                <h5 className="font-medium text-gray-900">Integração com iFood, 99 e Keeta</h5>
                <p className="text-gray-600 text-sm">Centralize todos os pedidos de delivery</p>
              </div>
            </div>
          </div>
        </div> */}
      </div>
    </div>
  </section>
);

export default AdditionalFeatures;